<template>
  <div>
    <div class="d-flex align-items-center mb-1">
      <b-button
        class="mr-1"
        variant="primary"
        :disabled="isDrawing"
        @click="drawNewPolygon([])"
      >
        <span>Start drawing new polygon</span>
      </b-button>
      <b-button
        variant="primary"
        :disabled="!isDrawing"
        @click="endDrawingPolygon"
      >
        <span>End drawing polygon</span>
      </b-button>
      <b-button
        class="ml-auto"
        variant="success"
        @click="emitChanges"
      >
        Save Changes
      </b-button>
    </div>
    <div
      ref="mapRef"
      class="map"
    />
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import {
  reactive, ref, onMounted,
} from '@vue/composition-api'
import { successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BButton,
  },
  props: {
    polygons: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, ctx) {
    const parsePolygonPathsToJsonArray = polygon => {
      const polygonArr = polygon.getPaths().getArray()
      const temp = polygonArr[0]
      const arr = []
      if (!temp?.length) {
        return []
      }
      for (let i = 0; i <= temp.length - 1; i += 1) {
        arr.push({
          lat: temp.getAt(i).lat(),
          lng: temp.getAt(i).lng(),
        })
      }
      return arr
    }
    const isDrawing = ref(false)
    const mapClickHandler = ref()
    const localPolygons = ref([])
    const mapRef = ref(null)

    const map = ref()
    const mapCenter = reactive({
      lat: 31.963158, lng: 35.930359,
    })
    function initMap() {
      // eslint-disable-next-line no-undef
      map.value = new google.maps.Map(mapRef.value, {
        zoom: 10,
        center: mapCenter,
      })
      map.value.setOptions({ draggableCursor: 'pointer' })
    }

    const drawNewPolygon = polygonPaths => {
      if (!polygonPaths.length) {
        isDrawing.value = true
      }
      // eslint-disable-next-line no-undef
      const polygon = new google.maps.Polygon({
        paths: polygonPaths && polygonPaths.length ? polygonPaths : [],
        map: map.value,
        editable: true,
        clickable: true,
      })
      polygon.set('id', Math.random().toString())

      // eslint-disable-next-line no-undef
      google.maps.event.addListener(polygon, 'rightclick', () => {
        polygon.setMap(null)
        const polygonId = polygon.get('id')
        const polygonIx = localPolygons.value.findIndex(el => el.get('id') === polygonId)
        localPolygons.value.splice(polygonIx, 1)
      })

      localPolygons.value.push(polygon)
      if (!polygonPaths.length) {
        mapClickHandler.value = e => {
          const coordinate = e.latLng.toJSON()
          const oldPath = parsePolygonPathsToJsonArray(polygon)
          polygon.setPaths([...oldPath, coordinate])
        }
        map.value.addListener('click', mapClickHandler.value)
      }
    }
    const endDrawingPolygon = () => {
      isDrawing.value = false
      // eslint-disable-next-line no-undef
      google.maps.event.clearListeners(map.value, 'click')
    }

    const emitChanges = () => {
      const arr = []
      localPolygons.value.forEach(polygon => {
        arr.push(parsePolygonPathsToJsonArray(polygon))
      })
      ctx.emit('path-set', arr)
      successNotification('Changed saved')
    }
    const initPolygons = () => {
      props.polygons.forEach(polygon => {
        drawNewPolygon(polygon)
      })
    }

    onMounted(() => {
      initMap()
      if (props.polygons.length) {
        initPolygons()
      }
    })
    return {
      isDrawing,
      drawNewPolygon,
      mapRef,
      emitChanges,
      localPolygons,
      endDrawingPolygon,
    }
  },
}

</script>

<style scoped>
.map {
  width: 100%;
  height: 400px;
}
</style>
